import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import logo from "../../assets/logo.png";

export default function NotFound() {
  const navigate = useNavigate();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <div className="bg-[#021610] text-white min-h-screen flex flex-col overflow-hidden">
      {/* NAVBAR */}
      <div className="fixed top-0 left-0 w-full bg-black/80 backdrop-blur-md z-20 flex items-center px-6 py-2">
        <button onClick={() => navigate("/tickets-store/")}>
          <img
            src={logo}
            alt="Afrodise"
            className="h-6 md:h-8 object-contain hover:opacity-80 transition"
          />
        </button>
      </div>

      {/* BACKGROUND EFFECTS */}
      <div className="fixed inset-0 pointer-events-none">
        {/* GLOW TOP LEFT */}
        <div
          className="absolute -top-40 -left-40 w-96 h-96 rounded-full"
          style={{
            background:
              "radial-gradient(circle, rgba(34,197,94,0.06) 0%, transparent 70%)",
          }}
        />
        {/* GLOW BOTTOM RIGHT */}
        <div
          className="absolute -bottom-40 -right-40 w-96 h-96 rounded-full"
          style={{
            background:
              "radial-gradient(circle, rgba(34,197,94,0.04) 0%, transparent 70%)",
          }}
        />

        {/* GRID LINES */}
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `
              linear-gradient(rgba(34,197,94,1) 1px, transparent 1px),
              linear-gradient(90deg, rgba(34,197,94,1) 1px, transparent 1px)
            `,
            backgroundSize: "60px 60px",
          }}
        />
      </div>

      {/* MAIN CONTENT */}
      <div className="flex-1 flex flex-col items-center justify-center px-4 pt-20 pb-16 relative z-10">
        {/* 404 NUMBER */}
        <div
          className="relative select-none mb-6"
          style={{
            opacity: mounted ? 1 : 0,
            transform: mounted ? "translateY(0)" : "translateY(20px)",
            transition: "opacity 0.6s ease, transform 0.6s ease",
          }}
        >
          <p
            className="font-black text-center leading-none"
            style={{
              fontSize: "clamp(100px, 20vw, 200px)",
              color: "transparent",
              WebkitTextStroke: "1px rgba(34,197,94,0.15)",
              letterSpacing: "-0.05em",
            }}
          >
            404
          </p>

          {/* OVERLAID SOLID TEXT */}
          <p
            className="font-black text-center leading-none absolute inset-0 flex items-center justify-center"
            style={{
              fontSize: "clamp(100px, 20vw, 200px)",
              color: "rgba(34,197,94,0.06)",
              letterSpacing: "-0.05em",
            }}
          >
            404
          </p>
        </div>

        {/* TEXT CONTENT */}
        <div
          className="text-center max-w-md"
          style={{
            opacity: mounted ? 1 : 0,
            transform: mounted ? "translateY(0)" : "translateY(20px)",
            transition: "opacity 0.6s ease 0.15s, transform 0.6s ease 0.15s",
          }}
        >
          <p className="text-[10px] tracking-widest text-green-400/70 uppercase mb-3">
            Página no encontrada
          </p>
          <h1 className="text-2xl md:text-3xl font-bold mb-3">
            Esta página no existe
          </h1>
          <p className="text-sm text-gray-400 leading-relaxed">
            El enlace que seguiste puede estar roto o la página puede haber sido
            eliminada.
          </p>
        </div>

        {/* DIVIDER */}
        <div
          className="w-px h-12 bg-gradient-to-b from-green-900/60 to-transparent my-8"
          style={{
            opacity: mounted ? 1 : 0,
            transition: "opacity 0.6s ease 0.3s",
          }}
        />

      </div>

      {/* BOTTOM TICKER */}
      <div
        className="fixed bottom-0 left-0 w-full border-t border-green-900/20 py-2 overflow-hidden"
        style={{
          opacity: mounted ? 1 : 0,
          transition: "opacity 0.6s ease 0.5s",
        }}
      >
        <div
          className="flex gap-12 whitespace-nowrap text-[10px] tracking-widest text-green-900/60 uppercase"
          style={{
            animation: "ticker 20s linear infinite",
          }}
        >
          {Array.from({ length: 8 }).map((_, i) => (
            <span key={i}>
              Afrodise Music · Exclusive Events · Live Experiences · Tickets
            </span>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes ticker {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
